export default __webpack_public_path__ + "images/3f038bb2f726e3f905d739edfd7a7684-pharma-logo.svg";